<div [hidden]="!(dataSource.data.length > 0)" #table>

  <div style="display: flex; align-items: center;">
    <!-- ช่องค้นหา -->
    <mat-form-field appearance="standard" style="width: 20%;">
      <mat-label>ค้นหา</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
    </mat-form-field>

    <div style="display: flex; align-items: center;">
      <span
        (click)="onExport()"
        style="cursor: pointer; margin-right: 16px;"
      >
        <img
          src="../../../../../assets/images/icon/excel.png"
          style="width: 24px; height: 24px;"
          alt="Excel Icon"
        />
      </span>

<!--      <span-->
<!--        *ngIf="page === 'TransactionElement' || page === 'TransactionPdfElement'"-->
<!--        (click)="onExportPDFAdmin()"-->
<!--        style="cursor: pointer; margin-right: 16px;"-->
<!--      >-->
<!--        <img-->
<!--          src="../../../../../assets/images/icon/pdf.png"-->
<!--          style="width: 24px; height: 24px;"-->
<!--          alt="PDF Icon"-->
<!--        />-->
<!--      </span>-->

<!--      <span-->
<!--        *ngIf="page === 'TransactionUserElement' || page === 'TransactionUserPdfElement'"-->
<!--        (click)="onExportPDFUser()"-->
<!--        style="cursor: pointer; margin-right: 16px;"-->
<!--      >-->
<!--        <img-->
<!--          src="../../../../../assets/images/icon/pdf.png"-->
<!--          style="width: 24px; height: 24px;"-->
<!--          alt="PDF Icon"-->
<!--        />-->
<!--      </span>-->

      <!-- Modified to conditionally show based on config -->
      <span
        *ngIf="(page === 'TransactionUserPdfElement' || page === 'TransactionPdfElement') && isElectronicTaxEnabled"
        (click)="onExportPDF()"
        style="cursor: pointer; display: flex; align-items: center;"
      >
        <img
          src="../../../../../assets/images/icon/print.png"
          style="width: 24px; height: 24px;"
          alt="Print Icon"
        />
        <span style="margin-left: 8px;">
          พิมพ์หลักฐานรับรอง<br/>
          การหักภาษี ณ ที่จ่าย
        </span>
      </span>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort class="table-scroll">
    <div *ngFor="let column of displayedColumns">
      <ng-container [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef [innerHTML]="(column | thaiLang)"></th>
        <td mat-cell *matCellDef="let element">
          <p class="center" *ngIf="isCheckColumnType(column) === 'code'">{{ element[column] }}</p>
          <p class="left" *ngIf="isCheckColumnType(column) === 'text'">{{ element[column] }}</p>
          <p class="center" *ngIf="isCheckColumnType(column) === 'date'">{{ element[column] | thaidate }}</p>
          <p class="right" *ngIf="isCheckColumnType(column) === 'currency'">{{ element[column] | bigdecimal }}</p>
          <span
            class="material-icons icon-refresh"
            *ngIf="isCheckColumnType(column) === 'icon-reset'"
            (click)="openDialogReset(element)">
              refresh
          </span>
          <span
            class="material-icons icon"
            *ngIf="isCheckColumnType(column) === 'icon-delete'"
            (click)="openDialogRemove(element)">
              delete
          </span>
          <span
            class="material-icons icon-inactive"
            *ngIf="isCheckColumnType(column) === 'icon-inactive'"
            (click)="openDialogInactive(element)">
              delete
          </span>
          <span
            class="material-icons icon-list"
            *ngIf="isCheckColumnType(column) === 'icon-document' && onCheckNote(element[column])"
            (click)="openDialogNote(element[column])">
              list_alt
          </span>
          <span
            class="material-icons icon-pdf"
            *ngIf="isCheckColumnType(column) === 'icon-pdf' && isWithHoldingTax(element['amountRate']) && isElectronicTaxEnabled"
            (click)="downloadPdf(element['docNo'])">
              picture_as_pdf
          </span>
        </td>
      </ng-container>
    </div>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator (page)="handlePage($event)" [length]="totalElements" [pageSizeOptions]="[50, 100]"
                 aria-label="Select page">
  </mat-paginator>
</div>
